import { render, staticRenderFns } from "./CongratsMenu.vue?vue&type=template&id=1fde7d47"
import script from "./CongratsMenu.vue?vue&type=script&lang=js"
export * from "./CongratsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports